"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIcon = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _Button = require("./Button.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _excluded = ["type", "isHover", "isActive", "isFocus", "semanticColor"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @deprecated
 * This component will be archived soon.
 * Use the {@link https://encore-web.spotify.net/?path=/docs/components-buttontertiary--icons ButtonTertiary} component with iconOnly prop instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-buttonicon--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ButtonIcon)
 */
var ButtonIcon = exports.ButtonIcon = /*#__PURE__*/_react["default"].forwardRef(function ButtonIcon(_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    isHover = _ref.isHover,
    isActive = _ref.isActive,
    isFocus = _ref.isFocus,
    semanticColor = _ref.semanticColor,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/_react["default"].createElement(_Button.Button, Object.assign({}, props, {
    ref: ref,
    type: type,
    $isHover: isHover,
    $isActive: isActive,
    $isFocus: isFocus,
    $isUsingKeyboard: isUsingKeyboard,
    $semanticColor: semanticColor,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ButtonIcon
  }));
});